import { Suspense, lazy } from "react";
import { useSession } from "../session/SessionProvider.js";
import type { SubscriptionInfo } from "../lib/api.js";

/**
 * E-BUNDLE-17 — Ladeschranke vor dem Subscription-Banner.
 *
 * `SubscriptionBanner` gibt fuer gesunde Mandanten `null` zurueck, lag aber mit
 * Statusverzweigung, Kopie-Schluesseln und Layout-Styles komplett im
 * Entry-Chunk. Die Subscription steht ohnehin erst nach der Antwort von
 * `GET /v1/auth/session` fest, das Banner kann also beim ersten Paint gar nicht
 * erscheinen.
 *
 * {@link mayNeedSubscriptionBanner} ist die billige Vorentscheidung: sie sagt
 * nur, ob ein Banner ueberhaupt in Frage kommt, und bleibt bewusst grosszuegig.
 * Die genaue Wahl trifft weiterhin `pickBannerSpec` in der nachgeladenen
 * Komponente; ein zu frueh geladener Chunk zeigt dort schlicht `null`. Die
 * Komponente selbst ist nicht angefasst.
 */
export function mayNeedSubscriptionBanner(subscription: SubscriptionInfo | undefined): boolean {
  if (!subscription) return false;
  // Nur der Normalfall wird ausgeschlossen: ein aktiver Mandant ohne
  // Ablaufdatum kann in `pickBannerSpec` keinen Zweig treffen.
  if (subscription.status === "active") return Boolean(subscription.validUntil);
  return true;
}

const SubscriptionBanner = lazy(async () => {
  const mod = await import("./SubscriptionBanner.js");
  return { default: mod.SubscriptionBanner };
});

export function SubscriptionBannerGate() {
  const session = useSession();
  if (!mayNeedSubscriptionBanner(session.subscription)) return null;
  return (
    <Suspense fallback={null}>
      <SubscriptionBanner />
    </Suspense>
  );
}
